import Vue from 'vue'
import loading from '../components/Center/Loading.vue'

// 扩展实例构造器
const LoadingConstructor = Vue.extend(loading)

// 创建一个vue实例，挂载元素为新创建的div
const initLoadingInstance = function () {
  return new LoadingConstructor({
    el: document.createElement('div')
  })
}

// 删除dom节点
const removeDom = (node) => {
  if (node.parentNode) {
    node.parentNode.removeChild(node)
  }
}

const instance = initLoadingInstance()
// 关闭loading
const closeLoading = () => {
  removeDom(instance.$el)
}

// 展示loading
const showLoading = function () {
  document.body.appendChild(instance.$el)
}

export default {
  showLoading,
  closeLoading
}
